import { Injectable, InputSignal } from '@angular/core';
import {
	NgbModal,
	NgbModalOptions,
	NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';

export type InputInitialization<T> = T extends new (
	...args: unknown[]
) => infer U
	? {
			[K in keyof U as U[K] extends InputSignal<unknown>
				? K
				: never]: U[K] extends InputSignal<infer V> ? V : never;
		}
	: never;

@Injectable({
	providedIn: 'root',
})
export class ModalService {
	constructor(private _ngbModalService: NgbModal) {}

	open<T>(
		content: T,
		options: NgbModalOptions,
		inputs: InputInitialization<T>,
	): NgbModalRef {
		const modal = this._ngbModalService.open(content, options);

		const component = modal['_contentRef'].componentRef;
		Object.keys(inputs).forEach((key) => {
			component.setInput(key, inputs[key]);
		});

		return modal;
	}

	get activeInstances() {
		return this._ngbModalService.activeInstances;
	}

	dismissAll(reason?: unknown) {
		this._ngbModalService.dismissAll(reason);
	}

	hasOpenModals() {
		return this._ngbModalService.hasOpenModals();
	}
}
